import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';

export const DialogCloseButton = styled(IconButton)({
  position: 'absolute',
  right: 8,
  top: 8
});

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '48%'
  }
}));

export const SelectButton = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 14px',
  border: '1px solid #c4c4c4',
  borderRadius: 8,
  backgroundColor: '#fff',
  cursor: 'pointer',
  minHeight: 42,
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: '#999'
  }
}));

export const ButtonContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  color: '#333'
});

export const ButtonLabel = styled('span')(({ theme }) => ({
  fontSize: 14,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem'
  }
}));

export const DatePickerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  justifyContent: 'center',
  marginTop: 8,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: 16,
    alignItems: 'center'
  }
}));

export const DatePickerWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    '& .MuiPickersCalendarHeader-root': {
      paddingLeft: 8,
      paddingRight: 8
    },
    '& .MuiDayCalendar-weekContainer': {
      margin: 0
    }
  }
}));

export const DatePickerLabel = styled('div')({
  fontSize: 14,
  fontWeight: 500,
  color: '#333',
  marginBottom: 8,
  textAlign: 'center'
});

export const TimeSelectContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  padding: '16px 0',
  '& .MuiTextField-root': {
    width: 100
  }
});

export const TimeColon = styled('span')({
  fontSize: 24,
  fontWeight: 500,
  color: '#333',
  paddingBottom: 4
});

export const MobileDatePickerDivider = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'block',
    width: '100%',
    height: 1,
    backgroundColor: '#e0e0e0',
    margin: '8px 0'
  }
}));

const rangeColor = 'rgba(6, 25, 35, 0.12)';
const selectedColor = '#061923';

export const RangeDay = styled(PickersDay)({
  backgroundColor: selectedColor,
  color: '#fff',
  '&:hover': {
    backgroundColor: selectedColor
  },
  '&.Mui-selected': {
    backgroundColor: selectedColor,
    color: '#fff'
  }
});

export const RangeDayStart = styled(PickersDay)({
  backgroundColor: selectedColor,
  color: '#fff',
  borderTopLeftRadius: '50%',
  borderBottomLeftRadius: '50%',
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  position: 'relative',
  '&::after': {
    content: '""',
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '50%',
    backgroundColor: rangeColor,
    zIndex: -1
  },
  '&:hover': {
    backgroundColor: selectedColor
  },
  '&.Mui-selected': {
    backgroundColor: selectedColor,
    color: '#fff'
  }
});

export const RangeDayEnd = styled(PickersDay)({
  backgroundColor: selectedColor,
  color: '#fff',
  borderTopRightRadius: '50%',
  borderBottomRightRadius: '50%',
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '50%',
    backgroundColor: rangeColor,
    zIndex: -1
  },
  '&:hover': {
    backgroundColor: selectedColor
  },
  '&.Mui-selected': {
    backgroundColor: selectedColor,
    color: '#fff'
  }
});

export const RangeDayMiddle = styled(PickersDay)({
  backgroundColor: rangeColor,
  color: '#333',
  borderRadius: 0,
  '&:hover': {
    backgroundColor: 'rgba(6, 25, 35, 0.2)'
  },
  '&.Mui-selected': {
    backgroundColor: rangeColor,
    color: '#333'
  }
});
